import * as React from 'react';
export interface INavMenuProps {
  className?: string
  children: React.ReactNode;
}
export function NavMenu(props: INavMenuProps) {
  const { className, children } = props;
  return (
    <nav className={className}>
      {children}
    </nav>
  )
}
